import { Model } from '@vuex-orm/core'
import OrderModel from './OrderModel'
import ItemModel from './ItemModel'

export default class LineItemModel extends Model {
  static entity = 'line_items'

  static nameSingular = 'Line Item'
  static namePlural = 'Line Items'

  static fields() {
    return {
      id: this.uid(),
      order_id: this.attr(null),
      order: this.belongsTo(OrderModel, 'order_id'),
      user_id: this.attr(null),
      item_id: this.attr(null),
      quantity: this.number(0),
      item_price: this.number(0),
      item_unit: this.string('').nullable(),
      item_name: this.string('').nullable(),
      item_date: this.attr(null),
      item: this.belongsTo(ItemModel, 'item_id'),
      type: this.string(this.lineItemTypes.PRODUCT),
      section_name: this.string('').nullable(),
      oversold: this.boolean(),
    }
  }

  static lineItemTypes = {
    FEE: 'FEE',
    PRODUCT: 'PRODUCT',
    DISCOUNT: 'DISCOUNT',
  }

  get item_price_usd() {
    return this.item_price / 100
  }

  get item_price_formatted() {
    const prefix = this.item_price_usd < 0 ? '-$' : '$'
    return `${prefix}${Math.abs(this.item_price_usd).toFixed(2)}`
  }

  get total_price() {
    return this.item_price * this.quantity
  }

  get total_price_usd() {
    return this.total_price / 100
  }

  /**
   * Get priced formatted like a -$D,DDD.CC
   */
  get total_price_formatted() {
    const prefix = this.total_price_usd < 0 ? '-$' : '$'
    return `${prefix}${Math.abs(this.total_price_usd).toFixed(2)}`
  }
}
